import axios from "axios";
import { ROUTES } from "../routes";

// Requests where a 401 is an expected, user-facing outcome (e.g. wrong
// password) rather than an expired/invalid session - these should not
// trigger a global logout redirect.
const UNAUTHENTICATED_REQUEST_URL_FRAGMENTS = ["/password/validate"];

function isUnauthenticatedRequest(url: string | undefined): boolean {
  if (!url) {
    return false;
  }
  return UNAUTHENTICATED_REQUEST_URL_FRAGMENTS.some((fragment) =>
    url.includes(fragment)
  );
}

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (
      axios.isAxiosError(error) &&
      error.response?.status === 401 &&
      !isUnauthenticatedRequest(error.config?.url)
    ) {
      try {
        localStorage.clear();
      } catch {
        // localStorage unavailable (e.g. private browsing) - fall through
        // and still redirect to the password page.
      }
      if (window.location.pathname !== ROUTES.password) {
        window.location.href = ROUTES.password;
      }
    }
    return Promise.reject(error);
  }
);
